export default class MetasClienteUploadModel {
  codRepres = '';

  codCli = '';

  metaQuantidade = '0';

  metaValor = '0';

  constructor(codRepres: string, codCli: string, metaQuantidade: string, metaValor: string) {
    this.codRepres = codRepres;
    this.codCli = codCli;
    this.metaQuantidade = metaQuantidade;
    this.metaValor = metaValor;
  }
}
